import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Footer from "../component/Footer";
import About from "../pages/About";
import Contact from "../pages/Contact";

import HeaderNavbar from "../component/HeaderNavbar";
import ZeroTrust from "../pages/Service/technology/ZeroTrust";
import SOAR from "../pages/Service/technology/SOAR";
import ArtificialIntelligence from '../pages/Service/technology/ArtificialIntelligence';
import DeceptionTechnology from '../pages/Service/technology/DeceptionTechnology';
import MachineLearning from '../pages/Service/technology/MachineLearning';

// Products
import EnterPriseMobilitySecurity from '../pages/Service/products/EnterPriseMobilitySecurity';
import EnterPriseNetworkServices from "../pages/Service/products/EnterPriseNetworkServices";
import DigitalWorkspace from '../pages/Service/products/DigitalWorkspace';
import DataManagement from "../pages/Service/products/DataManagement";
import Cloud from "../pages/Service/products/Cloud";
import Email from "../pages/Service/products/Email";
import Ransomware from "../pages/Service/products/Ransomeware";
import DigitalRisk from "../pages/Service/products/DigitalRisk";
import MachinesFight from "../pages/Service/products/MachinesFight";
import DataDriven from "../pages/Service/products/DataDriven";
import EmpowerEmployee from "../pages/Service/products/EmowerEmployee";
import Career from "../pages/company/Career";
import Partners from "../pages/company/Partner";
import Leadership from "../pages/company/Leadership";
import Endpoint from "../pages/Service/products/Endpoint";
import IcsSecurity from "../pages/Service/products/IcsSecurity";
import MDR from "../pages/Service/products/MDR";
import DigitalWorkforce from "../pages/Service/products/DigitalWorforce";
import ZeroTrustBlog from "../pages/blogs/ZeroTrustBlog";
import BlogArticle from "../pages/blogs/BlogArticle";
import WhatsAppButton from "../component/WhatsAppButton";
import ContactPopup from "../component/ContactPopup";



export default function Router() {
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer); // Cleanup function to clear the timer
    }, []);
    const [headerData, setHeaderData] = useState([]);

    return (
        <>
            <BrowserRouter>

                {/* <Header setHeaderData={setHeaderData} /> */}
                <HeaderNavbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    {/*Technology Services  */}
                    <Route path="/zero-trust" element={<ZeroTrust />} />
                    <Route path="/soar" element={<SOAR />} />
                    <Route path="/artificial-intelligence" element={<ArtificialIntelligence />} />
                    <Route path="/deception-technology" element={<DeceptionTechnology />} />
                    <Route path="/machine-learning" element={<MachineLearning />} />

                    {/* Products */}
                    <Route path="/enterprise-mobility-security" element={<EnterPriseMobilitySecurity />} />
                    <Route path="/enterprise-network-ndr" element={<EnterPriseNetworkServices />} />
                    <Route path="/digital-workspace" element={<DigitalWorkspace />} />
                    <Route path="/data-management" element={<DataManagement />} />
                    <Route path="/cloud" element={<Cloud />} />
                    <Route path="/email" element={<Email />} />
                    <Route path="/ransomware" element={<Ransomware />} />
                    <Route path="/digital-risk" element={<DigitalRisk />} />
                    <Route path="/machine-fight-back" element={<MachinesFight />} />
                    <Route path="/data-driven-decision" element={<DataDriven />} />
                    <Route path="/empower-employee" element={<EmpowerEmployee />} />
                    <Route path="/partners" element={<Partners />} />
                    <Route path="/leadership" element={<Leadership />} />
                    <Route path="/endpoint" element={<Endpoint />} />
                    <Route path="/ics-security" element={<IcsSecurity />} />
                    <Route path="/mdr" element={<MDR />} />
                    <Route path="/mdr" element={<MDR />} />
                    <Route path="/digital-workforce" element={<DigitalWorkforce />} />
                    {/* Company */}
                    <Route path="/career" element={<Career />} />
                    {/* Blog */}

                    <Route path="/blog/zero-trust-blog" element={<ZeroTrustBlog />} />
                    <Route path="/blog/cybersecurity-trends" element={<BlogArticle articleKey="cybersecurity" />} />
                    <Route path="/blog/ai-in-cybersecurity" element={<BlogArticle articleKey="ai" />} />
                    <Route path="/blog/cybersecurity-excellence" element={<BlogArticle articleKey="excellence" />} />
                </Routes>
                <ContactPopup />
                <WhatsAppButton />
                <Footer headerData={headerData} />
            </BrowserRouter >
        </>
    );
}
